import { render, staticRenderFns } from "./out-sider.vue?vue&type=template&id=6c323f5b&scoped=true&"
import script from "./out-sider.vue?vue&type=script&lang=js&"
export * from "./out-sider.vue?vue&type=script&lang=js&"
import style0 from "./out-sider.vue?vue&type=style&index=0&id=6c323f5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c323f5b",
  null
  
)

export default component.exports